module.exports = __webpack_public_path__ + "static/webmaintenace-39956ce289641cd01da12401611e0702.svg";